import React from "react"

import StyleEditingGroup from "./StyleEditingGroup"
import { registration } from "../../../modals/GraphEditModal"
import { trendFields } from "../../../modals/GraphEditModal/GraphFieldTable"

export default function TrendStyleEditor({ obs, rowStyle, adjustMetric, intl }) {
  return (
    <>
      {obs.style !== "box" && (
        <div style={rowStyle}>
          <div className={"col-12 text-center"}>
            {(trendFields?.style?.options || []).map((style) => {
              const label = trendFields?.style?.optionsRename?.[style] || style
              return (
                <span key={label}>
                  <input
                    style={{ marginLeft: "1px" }}
                    type="checkbox"
                    id={`${style}Check`}
                    checked={obs.style === style}
                    onChange={() => {
                      adjustMetric(obs, style, "style")
                    }}
                  />
                  &nbsp;
                  <label style={{ margin: "0" }}>{registration[`${label}_trend_option`](intl)}</label>
                  &nbsp;&nbsp;
                </span>
              )
            })}
          </div>
        </div>
      )}
      {!["points", "box"].includes(obs["style"]) && (
        <>
          <hr />
          <StyleEditingGroup
            rowStyle={rowStyle}
            obs={obs}
            intl={intl}
            adjustMetric={adjustMetric}
            intField={"strokeWidth"}
            modifierField={"strokeModifier"}
          />
        </>
      )}
      {!["line", "box"].includes(obs["style"]) && (
        <>
          <hr />
          <StyleEditingGroup
            rowStyle={rowStyle}
            obs={obs}
            intl={intl}
            adjustMetric={adjustMetric}
            intField={"pointSize"}
            modifierField={"pointModifier"}
          />
        </>
      )}
    </>
  )
}
